export default __webpack_public_path__ + "media/images/document-dossier-g151-orange-papier-icone-6119-96-6f7308c6151407e3228259cd08cb9b60.png";